import { Link } from 'react-router-dom';
import { useInView } from '../../hooks/useInView';
import { ShoppingBag, Shield, Leaf, Star, Check, Repeat } from 'lucide-react';
import { PRODUCT_IMAGES, SUBSCRIBE_PRICE } from '../../constants';

const trustSignals = [
{ icon: Shield, label: 'Premium Quality' },
{ icon: Leaf, label: 'Natural Formula' },
{ icon: Star, label: 'Made in USA' }];


export default function FinalCTASection() {
  const [ref, inView] = useInView(0.1);

  return (
    <section
      data-testid="final-cta-section"
      style={{
        position: 'relative',
        overflow: 'hidden',
        padding: '110px 0',
        backgroundColor: '#1B3D7E'
      }}>

      {/* Background bottle image tint */}
      <div style={{
        position: 'absolute', inset: 0,
        backgroundImage: `url(${PRODUCT_IMAGES.multipleBottles})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        opacity: 0.06,
        pointerEvents: 'none'
      }} />

      {/* Overlay */}
      <div style={{
        position: 'absolute', inset: 0,
        background: 'linear-gradient(to right, rgba(27,61,126,0.95) 0%, rgba(27,61,126,0.85) 50%, rgba(27,61,126,0.95) 100%)',
        pointerEvents: 'none'
      }} />

      <div ref={ref} className="max-w-4xl mx-auto px-6 md:px-12 text-center relative z-10">
        <div className={`fade-up ${inView ? 'visible' : ''}`}>
          <span style={{ fontFamily: 'Manrope, sans-serif', fontSize: '0.72rem', letterSpacing: '0.25em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.6)', fontWeight: 700, display: 'block', marginBottom: '20px' }}>
            Limited Stock Available
          </span>
          <h2 style={{
            fontFamily: 'Outfit, sans-serif',
            fontWeight: 800,
            fontSize: 'clamp(2.2rem, 5vw, 3.8rem)',
            color: '#FFFFFF',
            letterSpacing: '-0.025em',
            lineHeight: 1.1,
            marginBottom: '22px'
          }}>
            Reload Your<br />Performance Today
          </h2>

          <p style={{ fontFamily: 'Manrope, sans-serif', fontSize: '1.05rem', color: 'rgba(255,255,255,0.72)', maxWidth: '480px', margin: '0 auto 36px', lineHeight: 1.8 }}>
            Join thousands of men who have already reclaimed their vitality with RELOAD&apos;s premium natural formula.
          </p>

          <Link
            to="/shop"
            data-testid="final-cta-btn"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '10px',
              backgroundColor: '#FFFFFF',
              color: '#1B3D7E',
              fontFamily: 'Manrope, sans-serif',
              fontWeight: 800,
              textTransform: 'uppercase',
              letterSpacing: '0.12em',
              fontSize: '0.9rem',
              padding: '18px 40px',
              borderRadius: '100px',
              textDecoration: 'none',
              transition: 'all 0.2s ease',
              marginBottom: '16px'
            }}
            onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 8px 30px rgba(0,0,0,0.2)'; }}
            onMouseLeave={(e) => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = 'none'; }}
            className="!text-[#1B3D7E] !bg-[#FFFFFF]">
            <ShoppingBag size={18} strokeWidth={2} />
            Buy Now — £24.99
          </Link>

          {/* Subscribe nudge */}
          <div style={{ marginBottom: '28px' }}>
            <Link
              to="/shop"
              data-testid="final-cta-subscribe-link"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '7px',
                color: 'rgba(255,255,255,0.65)',
                fontFamily: 'Manrope, sans-serif',
                fontSize: '0.82rem',
                fontWeight: 600,
                textDecoration: 'none',
                transition: 'color 0.2s',
                borderBottom: '1px solid rgba(255,255,255,0.25)',
                paddingBottom: '2px',
              }}
              onMouseEnter={(e) => e.currentTarget.style.color = 'rgba(255,255,255,0.9)'}
              onMouseLeave={(e) => e.currentTarget.style.color = 'rgba(255,255,255,0.65)'}
            >
              <Repeat size={13} strokeWidth={2} />
              or Subscribe & Save from £{SUBSCRIBE_PRICE.toFixed(2)}/mo — Included UK Delivery
            </Link>
          </div>

          {/* Trust signals */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
            {trustSignals.map(({ icon: Icon, label }) =>
            <div key={label} className="flex items-center gap-2">
                <Icon size={14} style={{ color: 'rgba(255,255,255,0.6)' }} strokeWidth={1.5} />
                <span style={{ fontFamily: 'Manrope, sans-serif', fontSize: '0.72rem', color: 'rgba(255,255,255,0.6)', letterSpacing: '0.15em', textTransform: 'uppercase', fontWeight: 600 }}>
                  {label}
                </span>
              </div>
            )}
          </div>

          {/* Money-back */}
          <div style={{ marginTop: '24px', display: 'inline-flex', alignItems: 'center', gap: '8px', backgroundColor: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)', padding: '10px 20px', borderRadius: '100px' }}>
            <Check size={13} style={{ color: 'rgba(255,255,255,0.7)' }} />
            <span style={{ fontFamily: 'Manrope, sans-serif', fontSize: '0.75rem', color: 'rgba(255,255,255,0.7)', fontWeight: 600 }}>
              30-Day Money-Back Guarantee &nbsp;|&nbsp; Free UK Delivery Over £30
            </span>
          </div>
        </div>
      </div>
    </section>);

}